import Vue from 'vue'
import Vuex from 'vuex'
import { storage } from './js/Storage'

// Vuex Modules
import navigation from './store/navigation'
import share from './store/share'
import playout from './store/playout'

Vue.use(Vuex)

const data = {
  isBeta: false,
  isBetaOpen: true,
  isRegisteredUser: false,
  isSignedInUser: false,
  isLoading: false,
  showAppUpdateNotice: false,
  showConnectivityNotice: false,
  showRefreshNotice: false,
  dialogueTitle: null,
  dialogueSubtitle: null,
  signInReason: null,
  passwordResetToken: null,
  now: new Date(),
  notificationsEnabled: storage.areNotificationsEnabled(),
  notificationsMuted: false
}

export default new Vuex.Store({
  modules: {
    navigation, share, playout
  },
  state: {
    ...data
  },
  mutations: {
    updateTime (state) {
      state.now = new Date()
    },
    showLoading (state) {
      state.isLoading = true
    },
    hideLoading (state) {
      state.isLoading = false
    },
    showAppUpdateNotice (state) {
      state.showAppUpdateNotice = true
      state.showRefreshNotice = false
    },
    hideAppUpdateNotice (state) {
      state.showAppUpdateNotice = false
    },
    performAppUpdate (state) {
    },
    declineAppUpdate (state) {
    },
    showConnectivityNotice (state) {
      state.showConnectivityNotice = true
    },
    hideConnectivityNotice (state) {
      state.showConnectivityNotice = false
    },
    showRefreshNotice (state) {
      if (!state.showAppUpdateNotice) {
        state.showRefreshNotice = true
      }
    },
    hideRefreshNotice (state) {
      state.showRefreshNotice = false
    },
    performRefresh (state) {
    },
    declineRefresh (state) {
    },
    showCookiePopup () {},
    isRegisteredUser (state, isRegisteredUser) {
      state.isRegisteredUser = isRegisteredUser
    },
    isSignedInUser (state, isSignedInUser) {
      state.isSignedInUser = isSignedInUser
    },
    startSignIn (state, reason) {
      state.signInReason = reason
    },
    startPasswordReset (state, defaultUsername) {
      state.defaultUsername = defaultUsername
    },
    performPasswordReset (state, token) {
      state.passwordResetToken = token
    },
    showDialogue (state, detail) {
      state.dialogueTitle = detail.title
      state.dialogueSubtitle = detail.subtitle
    },
    hideDialogue (state) {
      state.dialogueTitle = null
      state.dialogueSubtitle = null
    },
    showDeleteAccount (state) {
    },
    toggleNotifications (state) {
      state.notificationsEnabled = !state.notificationsEnabled
      storage.enableNotifications(state.notificationsEnabled)
    },
    unmuteNotifications (state) {
      state.notificationsMuted = false
    },
    muteNotifications (state) {
      state.notificationsMuted = true
    },
    share (state, sharingData) {
      state.sharingData = sharingData
    }
  },
  data: {
  },
  actions: {
    start ({ commit }) {
      console.info('store starts')
      setInterval(() => {
        commit('updateTime')
      }, 1000 * 10)
    }
  }
})
